import { network } from 'services/network';

export const getSubProgramPreferenceP6ExcelExport = (subProgramId) => {
    return network.get(`api/bo/getSubProgramPreferenceP6ExcelExport?subProgramId=${subProgramId}`).then((response) => {
        return response.data;
    });
};
